import { useState, useEffect, useContext } from 'react'
import { useLocation } from 'react-router-dom'
import { CarritoContext } from '../context/carritoContext'
import { obtenerPresupuestoItems, obtenerPublicacion } from '../servicios/compraService'
import { buscarPorId } from '../servicios/usuarioService'
import PasarelaPago from './PasarelaPago'

const Compra = () => {
  const [itemsCompra, setItemsCompra] = useState([])
  const location = useLocation()

  const {
    idPresupuestoComprar,
    idPublicacionComprar,
    items,
    cantidadCompra,
    precioUnitario
  } = useContext(CarritoContext)

  const obtenerUsuario = async (idUsuario) => {
    const { data: usuarioTemp } = await buscarPorId(idUsuario)
    return usuarioTemp
  }

  const obtenerItems = async (idPresupuestoComprar, idPublicacionComprar, items) => {
    //si viene de presupuestos
    if (idPresupuestoComprar > 0) {
      const { data: itemsTemp } = await obtenerPresupuestoItems(
        parseInt(localStorage.getItem('idUsuario')),
        idPresupuestoComprar
      )
      setItemsCompra(itemsTemp)
    }
    //si viene de publicaciones
    else if (idPublicacionComprar > 0) {
      const { data: itemsTemp } = await obtenerPublicacion(
        parseInt(localStorage.getItem('idUsuario')),
        idPublicacionComprar
      )
      const usrVendedor = await obtenerUsuario(itemsTemp[0].idVendedor)
      setItemsCompra([
        {
          ...itemsTemp[0],
          precioUnitario: precioUnitario || itemsTemp[0].precioUnitario,
          ...location.state.imputacion,
          alicuota:
            items.filter((item) => item.idPublicacion === itemsTemp[0].idPublicacion)[0]
              ?.alicuota || itemsTemp[0].alicuota,
          cantidad: cantidadCompra,
          ...usrVendedor
        }
      ])
    }
    //si viene del carrito
    else if (
      items.length > 0 &&
      idPublicacionComprar === 0 &&
      idPresupuestoComprar === 0
    ) {
      setItemsCompra(items)
    }
  }

  useEffect(() => {
    obtenerItems(idPresupuestoComprar, idPublicacionComprar, items)
  }, [idPresupuestoComprar, idPublicacionComprar])

  return (
    <>
      <br />
      <PasarelaPago itemsCompra={itemsCompra} />
    </>
  )
}

export default Compra
